<template>
  <div>
    <v-card class="leads">
      <v-card-text>
        <v-chip-group column>
          <v-chip small v-if="getDailyConfigs.kind.length!==0"><b class="mr-1">Kind:</b>{{getDailyConfigs.kind.join(', ')}}</v-chip>
          <v-chip small v-if="getDailyConfigs.date!==null"><b class="mr-1">Date:</b>{{getDailyConfigs.date}}</v-chip>
          <v-chip small v-if="getDailyConfigs.voidLead"><b class="mr-1">Voided Leads</b></v-chip>
        </v-chip-group>

        <v-data-table :loading="getDailyLeadsLoading" :headers="headers" :items="getDailyLeads" :expanded.sync="expanded"  show-expand :item-class="isPremium" class="body--text" :server-items-length="getDailyConfigs.paginationCount" :page.sync="getDailyConfigs.paginationPage" :options.sync="options" :footer-props="{itemsPerPageOptions: itemsPerPageOptions}">

          <template v-slot:item.creation_timestamp="{ item }">{{ item.creation_timestamp | formatDate | textPlaceholder }}</template>
          <template v-slot:item.id="{ item }"><a :href="`/leads/${item.id}`">{{ item.id | textPlaceholder }}</a></template>
          <template v-slot:item.kind="{ item }">{{ item.kind | formatStatus | textPlaceholder }}</template>
          <template v-slot:item.status="{ item }">{{ item.status | textPlaceholder }}</template>
          <template v-slot:item.sales_person="{ item }">
            <div v-if="isEmpty(item.sales_person) || item.sales_person === 'unassigned'" @click="assignSales(item.id)"><a>Assign to me</a></div>
            <div v-else>{{ item.sales_person | textPlaceholder }}</div>
          </template>
          <template v-slot:item.source="{ item }"><span class="leads__source">{{ item.source | textPlaceholder }}</span></template>
          <template v-slot:item.channel="{ item }">{{ item.channel | textPlaceholder }}</template>
          <template v-slot:item.business_name="{ item }">{{ item.business_name | textPlaceholder }}</template>
          <template v-slot:item.customer_name="{ item }">{{ item.contact.name | textPlaceholder }}</template>
          <template v-slot:item.phone_number="{ item }"><a :href="!isEmpty(item.contact.phone_number) ? `tel:${item.contact.phone_number}` : '#'">{{ item.contact.phone_number | textPlaceholder }}</a></template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-row align="center" justify="space-between" no-gutters :class="$vuetify.breakpoint.mdAndUp ? '' : 'pt-5'">
                <v-col cols="12" md="2"><span class="font-weight-bold">source ID: </span>{{ item.source_id | textPlaceholder }}</v-col>
                <v-col cols="12" md="2"><span class="font-weight-bold">Origin: </span>{{ item.origin | textPlaceholder }}</v-col>
                <v-col cols="12" md="3"><span class="font-weight-bold">Industry: </span>{{ item.industry | textPlaceholder }}</v-col>
                <v-col cols="12" md="3"><span class="font-weight-bold">Email: </span>{{ item.contact.email_address | textPlaceholder }}</v-col>
                <v-col cols="12" md="2" :class="$vuetify.breakpoint.mdAndUp ? 'd-flex justify-end' : ''">
                  <v-btn small outlined color="warning" @click="voidLead(item)">VOID LEAD</v-btn>
                </v-col>
              </v-row>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <EditVoidReason :lead="voidReasonLead" :dialogOpen="voidReasonOpen" @close-dialog="voidReasonOpen=false" />
  </div>
</template>

<script>
  import EditVoidReason from './EditVoidReason';
  import { mapGetters, mapActions } from "vuex";
  import moment from "moment";

  export default {
    components: {EditVoidReason},
    data() {
      return {
        voidReasonOpen: false,
        voidReasonLead: '',
        options: {
          sortBy: ['creation_timestamp'],
          sortDesc: true,
          itemsPerPage: 50,
          kind: [],
          voidlead: false,
        },
        itemsPerPageOptions: [5,10,15,25,50],
        expanded: [],
        sortBy: 'creation_timestamp',
        sortDesc: true,
        singleExpand: false,
        OLD_CRM_LINK: process.env.VUE_APP_API_HOST || `https://ctst-testing.appspot.com/`,
        headers: [
          { text: 'Created', align: 'start', sortable: true, value: 'creation_timestamp', width: '220px'},
          { text: 'ID', value: 'id' },
          { text: 'Type', value: 'kind' },
          { text: 'Status', value: 'status' },
          { text: 'Sales Person', value: 'sales_person' },
          { text: 'Source', value: 'source', width: '100px' },
          { text: 'Channel', value: 'channel', width: '150px' },
          { text: 'Business Name', value: 'business_name', width: '150px' },
          { text: 'Name', value: 'contact.name' },
          { text: 'Phone', value: 'contact.phone_number' },
          { text: '', value: 'data-table-expand' },
        ],
      }
    },

    filters: {
      textPlaceholder(val) {
        if(val === null || val === "" || val === undefined) return "-";
        return val;
      },
      formatStatus(val) {
        const map = {"voip": "VoIP", "web": "Website", "telco": "Telco"};
        return map[val.toLowerCase()];
      }
    },

    computed: {
      ...mapGetters("auth", ["getUser"]),
      ...mapGetters("daily", ["getDailyLeads", "getDailyLeadsLoading", "getDailyConfigs"]),
      ...mapGetters('globals', ["hasUserGotRoles"]),
    },

    methods: {
      ...mapActions("daily", ["loadDailyLeads", "assignSalesPerson","updateDailyPagination","getVoidReasons"]),
      ...mapActions('alerts', ['setAlert']),
      isEmpty(val) {
        return val === null || val === "" || val === undefined;
      },
      assignSales(leadId) {
        const sales_person = this.getUser.email.split("@")[0];
        this.assignSalesPerson({ leadId, payload: { sales_person } });
      },
      voidLead(item) {
        if(this.hasUserGotRoles(["can-void-leads"])) {
          this.voidReasonLead = item;
          this.voidReasonOpen = true;
        } else {
          this.setAlert({ type: 'error', message: 'You are not authorised to void leads' });
        }
      },
      isPremium(item) {
        return item.is_premium_lead ? 'is-premium' : '';
      },
      kind(item) {
        const map = { "voip": "voip", "web": "sites", "telco": "phonelines" };
        return map[item];
      }
    },

    async created() {
      await this.getVoidReasons();
    },

    watch: {
      immediate: true,
      options: {
        handler () {
          this.updateDailyPagination(this.options);
        },
        deep: true,
      },
    },
  }
</script>

<style>
  .is-premium {
    background-color: rgba(255, 255, 0, 0.404) !important;
  }

  .leads__source {
    word-break: break-word;
  }
</style>
